import React, { useEffect, useRef, useState } from 'react';

import { LoadingPlaceholder } from '../../loading-placeholder';

import styles from './pdf-preview.css';

type Props = {
  pdfUrl: string;
  previewUrl: string;
  altTitle?: string;
};

export const PdfPreview: React.FC<Props> = ({ pdfUrl, previewUrl, altTitle = '' }) => {
  const [isImgLoading, setIsImgLoading] = useState<boolean>(true);
  const onImgLoad = (): void => setIsImgLoading(false);
  const imageStyle = isImgLoading ? { display: 'none' } : {};
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    imgRef.current?.complete && setIsImgLoading(false);
  }, []);

  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a className={styles.container} href={pdfUrl} target="_blank" data-testid="pdf-link" data-cy="pdf-link">
      {isImgLoading ? <LoadingPlaceholder testId="pdf-preview-loading" /> : null}
      <img
        className={styles.preview}
        src={previewUrl}
        alt={altTitle}
        style={imageStyle}
        onLoad={onImgLoad}
        onError={onImgLoad}
        ref={imgRef}
      />
    </a>
  );
};
